import React, { useState } from "react";
import Sidebar from "../../Components/Sidebar/Sidebar";
import Header from "../../Components/Header/Header";
import classes from "./MedicalRecords.module.css"; 
import VisitDetailModal from "./VisitDetailModal"; 
import { FiFileText } from "react-icons/fi"; 
import { 
    FaUser, FaPhoneAlt, FaEnvelope, FaCalendarAlt, 
    FaChevronRight, FaChevronDown, FaPencilAlt, FaEllipsisV,
    FaStethoscope, FaPills, FaFlask, FaXRay, FaClipboardList,
    FaFilePdf, FaDownload, FaPlus
} from "react-icons/fa";
import { MdBloodtype, MdWarning, MdCheckCircle } from "react-icons/md";

/* --- DATA --- */
const visitsData = [
    { id: 1, date: "21 May 2024", time: "10:30 AM", type: "OPD Visit", doctor: "Dr. James Wilson", dept: "Cardiology", reason: "Chest pain and discomfort", status: "Completed" },
    { id: 2, date: "15 Apr 2024", time: "11:15 AM", type: "OPD Visit", doctor: "Dr. James Wilson", dept: "Cardiology", reason: "Follow up", status: "Completed" },
    { id: 3, date: "13 Mar 2024", time: "09:00 AM", type: "OPD Visit", doctor: "Dr. Sarah Ahmed", dept: "General Medicine", reason: "Fever and headache", status: "Completed" },
    { id: 4, date: "05 Feb 2024", time: "02:30 PM", type: "Emergency", doctor: "Dr. Michael Lee", dept: "Emergency", reason: "High blood pressure", status: "Completed" },
    { id: 5, date: "18 Jan 2024", time: "09:45 AM", type: "OPD Visit", doctor: "Dr. James Wilson", dept: "Cardiology", reason: "Routine checkup", status: "Completed" },
];

/* --- FULL TIMELINE DATABASE RESTORED --- */
const fullTimelineDatabase = {
    1: [ // Timeline for "21 May 2024"
        { id: 101, time: "10:30 AM", color: "#22C55E", icon: <FaCalendarAlt />, title: "OPD Visit with Dr. James Wilson (Cardiology)", desc: "Chest pain and discomfort", action: "View Details" },
        { id: 102, time: "11:10 AM", color: "#8B5CF6", icon: <FaFlask />, title: "Lab Test - Complete Blood Count (CBC)", desc: "", action: "View Result" },
        { id: 103, time: "11:30 AM", color: "#F59E0B", icon: <FaPills />, title: "Prescription Added", desc: "Atorvastatin 20mg, Aspirin 75mg", action: "View Prescription" },
        { id: 104, time: "11:45 AM", color: "#3B82F6", icon: <FaFilePdf />, title: "Document Added", desc: "ECG Report", action: "View Document" },
    ],
    2: [ // Timeline for "15 Apr 2024"
        { id: 201, time: "11:15 AM", color: "#22C55E", icon: <FaCalendarAlt />, title: "Follow-up Visit with Dr. James Wilson", desc: "BP Check and medication review", action: "View Details" },
        { id: 202, time: "11:45 AM", color: "#8B5CF6", icon: <FaFlask />, title: "Lab Test - Lipid Profile", desc: "", action: "View Result" },
    ],
    3: [ // Timeline for "13 Mar 2024"
        { id: 301, time: "09:00 AM", color: "#22C55E", icon: <FaCalendarAlt />, title: "OPD Visit with Dr. Sarah Ahmed", desc: "Fever and headache", action: "View Details" },
        { id: 302, time: "09:30 AM", color: "#8B5CF6", icon: <FaFlask />, title: "Lab Test - Dengue NS1", desc: "", action: "View Result" },
        { id: 303, time: "10:00 AM", color: "#F59E0B", icon: <FaPills />, title: "Prescription Added", desc: "Paracetamol 500mg, Ibuprofen 400mg", action: "View Prescription" },
    ],
    4: [ // Timeline for "05 Feb 2024"
        { id: 401, time: "02:30 PM", color: "#EF4444", icon: <FaCalendarAlt />, title: "Emergency Visit with Dr. Michael Lee", desc: "High blood pressure", action: "View Details" },
        { id: 402, time: "03:15 PM", color: "#F59E0B", icon: <FaPills />, title: "Prescription Added", desc: "Amlodipine 5mg, Losartan 50mg", action: "View Prescription" },
    ],
    5: [ // Timeline for "18 Jan 2024"
        { id: 501, time: "09:45 AM", color: "#22C55E", icon: <FaCalendarAlt />, title: "Routine Checkup with Dr. James Wilson", desc: "Routine checkup", action: "View Details" },
        { id: 502, time: "10:15 AM", color: "#3B82F6", icon: <FaFilePdf />, title: "Document Added", desc: "Annual Health Report", action: "View Document" },
    ]
};

const summaryData = [ { id: 1, label: "Total Visits", count: 12, icon: <FaCalendarAlt /> }, { id: 2, label: "Diagnoses", count: 8, icon: <FaStethoscope /> }, { id: 3, label: "Medications", count: 15, icon: <FaPills /> }, { id: 4, label: "Allergies", count: 1, icon: <MdWarning /> }, { id: 5, label: "Lab Tests", count: 23, icon: <FaFlask /> }, { id: 6, label: "Imaging Tests", count: 6, icon: <FaXRay /> }, { id: 7, label: "Procedures", count: 3, icon: <FaClipboardList /> }, { id: 8, label: "Documents", count: 9, icon: <FiFileText /> } ];
const notesData = [ { id: 1, date: "21 May 2024", time: "10:32 AM", doctor: "Dr. James Wilson", text: "Patient advised to reduce salt intake and follow low fat diet. Regular exercise recommended. Review after 1 month." }, { id: 2, date: "15 Apr 2024", time: "10:20 AM", doctor: "Dr. James Wilson", text: "Patient is responding well to medication. Continue current treatment." } ];
const documentsData = [ { id: 1, name: "ECG Report", date: "21 May 2024", size: "245 KB" }, { id: 2, name: "Prescription - 21 May 2024", date: "21 May 2024", size: "123 KB" }, { id: 3, name: "Consultation Note", date: "21 May 2024", size: "180 KB" } ];
const allTabs = ["Overview", "Visits", "Diagnoses", "Prescriptions", "Lab Results", "Imaging", "Procedures", "Documents", "Immunizations", "Vitals", "Allergies", "History"];

export default function MedicalRecords() {
    const [activeTab, setActiveTab] = useState("Overview");
    const [selectedVisitId, setSelectedVisitId] = useState(1);
    
    // Modal States
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedVisitData, setSelectedVisitData] = useState(null);

    // Get the timeline for the currently selected visit
    const activeTimeline = fullTimelineDatabase[selectedVisitId] || [];

    const handleOpenDetails = (visitId) => {
        const visit = visitsData.find(v => v.id === visitId);
        if(visit) {
            setSelectedVisitData(visit);
            setIsModalOpen(true);
        }
    };

    const handleAction = (actionName, data) => {
        console.log(`Action triggered: ${actionName}`, data);
    };

    return (
        <div className={classes.page}>
            <Sidebar />
            <div className={classes.mainWrapper}>
                <Header />
                <div className={classes.contentArea}>
                    
                    {/* --- HEADER --- */}
                    <div className={classes.topSection}>
                        <div>
                            <h1 className={classes.pageTitle}>Medical Records</h1>
                            <p className={classes.breadcrumb}>Medical Records <FaChevronRight /> Patient Summary</p>
                        </div>
                        <div className={classes.topButtons}>
                            <button className={classes.btnEdit} onClick={() => handleAction("Edit Patient")}><FaPencilAlt /> Edit Patient</button>
                            <button className={classes.btnMore}><FaEllipsisV /> More <FaChevronDown /></button>
                        </div>
                    </div>

                    {/* --- PROFILE --- */}
                    <div className={classes.profileCard}>
                        <div className={classes.profileGrid}>
                            <div className={classes.profileLeft}>
                                <div className={classes.profileAvatar}><FaUser /></div>
                                <div className={classes.profileInfo}>
                                    <h2>John Doe</h2>
                                    <p className={classes.patientId}>OPD - 12345 &nbsp;|&nbsp; 34 Y / Male</p>
                                    <div className={classes.contactRow}>
                                        <span><FaPhoneAlt /> +1 987 654 3210</span>
                                        <span><FaEnvelope /> johndoe@email.com</span>
                                    </div>
                                    <div className={classes.statusBadge}><MdCheckCircle /> Active</div>
                                </div>
                            </div>

                            <div className={classes.profileMiddle}>
                                <div className={classes.vitalItem}><span className={classes.vitalLabel}>Blood Group</span><span className={classes.vitalValue}><MdBloodtype /> O+</span></div>
                                <div className={classes.vitalItem}><span className={classes.vitalLabel}>Allergies</span><span className={classes.vitalValue}>Penicillin</span></div>
                                <div className={classes.vitalItem}><span className={classes.vitalLabel}>Chronic Conditions</span><span className={classes.vitalValue}>Hypertension</span></div>
                                <div className={classes.vitalItem}><span className={classes.vitalLabel}>Primary Doctor</span><span className={classes.vitalValue}>Dr. James Wilson</span><span className={classes.vitalSub}>Cardiologist</span></div>
                            </div>

                            <div className={classes.profileRight}>
                                <div className={classes.dateItem}><span className={classes.dateLabel}>Last Visit</span><span className={classes.dateValue}>21 May 2024</span><span className={classes.dateSub}>10:30 AM</span></div>
                                <div className={classes.dateItem}><span className={classes.dateLabel}>Next Appointment</span><span className={classes.dateValue}>28 May 2024</span><span className={classes.dateSub}>09:00 AM</span></div>
                            </div>
                        </div>
                    </div>

                    {/* --- TABS --- */}
                    <div className={classes.tabsContainer}>
                        {allTabs.map(tab => (
                            <button key={tab} className={`${classes.tab} ${activeTab === tab ? classes.activeTab : ''}`} onClick={() => setActiveTab(tab)}>
                                {tab}
                            </button>
                        ))}
                    </div>

                    {/* --- MAIN GRID --- */}
                    <div className={classes.mainGrid}>
                        <div className={classes.leftCol}>
                            {/* Visits */}
                            <div className={classes.sectionCard}>
                                <div className={classes.sectionHeader}>
                                    <h3>Recent Visits</h3>
                                    <span className={classes.viewAll} onClick={() => handleAction("View All Visits")}>View All Visits</span>
                                </div>
                                <table className={classes.visitsTable}>
                                    <thead><tr><th>Visit Date</th><th>Visit Type</th><th>Doctor</th><th>Department</th><th>Reason for Visit</th><th>Status</th></tr></thead>
                                    <tbody>
                                        {visitsData.map((v) => (
                                            <tr key={v.id} onClick={() => setSelectedVisitId(v.id)} className={`${classes.visitRow} ${selectedVisitId === v.id ? classes.activeVisitRow : ''}`} style={{ cursor: 'pointer' }}>
                                                <td>{v.date}<br/><span className={classes.subText}>{v.time}</span></td>
                                                <td>{v.type}</td><td>{v.doctor}</td><td>{v.dept}</td><td>{v.reason}</td>
                                                <td><span className={classes.statusCompleted}>{v.status}</span></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* Timeline - Restored fully */}
                            <div className={classes.sectionCard}>
                                <div className={classes.sectionHeader}>
                                    <h3>Timeline for {visitsData.find(v => v.id === selectedVisitId)?.date || 'Visit'}</h3>
                                    <span className={classes.viewAll} onClick={() => handleAction("View Full Timeline")}>View Full Timeline</span>
                                </div>
                                <div className={classes.timelineContainer}>
                                    {activeTimeline.length > 0 ? (
                                        activeTimeline.map((t, i) => (
                                            <div key={t.id} className={classes.timelineItem}>
                                                <div className={classes.timelineLeft}>
                                                    <div className={classes.timelineDate}>{t.time}</div>
                                                    <div className={classes.timelineIcon} style={{ borderColor: t.color, color: t.color, background: `${t.color}20` }}>{t.icon}</div>
                                                    {i !== activeTimeline.length - 1 && <div className={classes.timelineLine} style={{ backgroundColor: t.color }}></div>}
                                                </div>
                                                <div className={classes.timelineRight}>
                                                    <div className={classes.timelineContent}>
                                                        <h4>{t.title}</h4>
                                                        {t.desc && <p>{t.desc}</p>}
                                                    </div>
                                                    {/* The "View Details" button passes the ID to the modal */}
                                                    <button className={classes.timelineBtn} onClick={() => handleOpenDetails(selectedVisitId)}>
                                                        {t.action}
                                                    </button>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <p style={{ textAlign: 'center', color: '#6B7280', padding: '20px 0' }}>No timeline events available for this visit.</p>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className={classes.rightCol}>
                            <div className={classes.sectionCard}>
                                <div className={classes.sectionHeader}><h3>Medical Summary</h3><button className={classes.downloadBtn} onClick={() => handleAction("Download Summary")}><FaDownload /> Download Summary</button></div>
                                <div className={classes.summaryGrid}>
                                    {summaryData.map((s) => (
                                        <div key={s.id} className={classes.summaryItem}>
                                            <div className={classes.summaryIcon}>{s.icon}</div>
                                            <span className={classes.summaryLabel}>{s.label}</span>
                                            <span className={classes.summaryCount}>{s.count}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className={classes.sectionCard}>
                                <div className={classes.sectionHeader}><h3>Important Notes</h3><button className={classes.addNoteBtn} onClick={() => handleAction("Add Note")}><FaPlus /> Add Note</button></div>
                                <div className={classes.notesList}>
                                    {notesData.map((n) => (
                                        <div key={n.id} className={classes.noteItem}>
                                            <div className={classes.noteHeader}>{n.date} <span className={classes.subText}>{n.time}</span> <span className={classes.noteDoc}>| {n.doctor}</span></div>
                                            <p className={classes.noteText}>{n.text}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className={classes.sectionCard}>
                                <div className={classes.sectionHeader}><h3>Documents</h3><span className={classes.viewAll} onClick={() => handleAction("View All Documents")}>View All Documents</span></div>
                                <div className={classes.documentsList}>
                                    {documentsData.map((d) => (
                                        <div key={d.id} className={classes.documentItem}>
                                            <div className={classes.docIcon}><FiFileText /></div>
                                            <div className={classes.docInfo}><h4>{d.name}</h4><p>{d.date} <span className={classes.subText}>| PDF | {d.size}</span></p></div>
                                            <button className={classes.docDownload} onClick={() => handleAction("Download Document", d)}><FaDownload /></button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* --- RENDER THE MODAL HERE --- */}
            <VisitDetailModal 
                isOpen={isModalOpen} 
                onClose={() => setIsModalOpen(false)} 
                visitData={selectedVisitData} 
            />
        </div>
    );
}